import "core-js/modules/es.array.push.js";
import { useCssVars as _useCssVars } from 'vue';
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66f5c035"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  style: {
    "width": "100%",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "background-color": "var(--atbg-color)",
    "position": "relative"
  }
};
const _hoisted_2 = {
  key: 0,
  style: {
    "flex": "1"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "area-center",
  style: {
    "margin-right": "2px"
  }
};
const _hoisted_4 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  style: {
    "font-size": "14px",
    "color": "#147797",
    "cursor": "pointer",
    "margin-right": "30px"
  }
};
const _hoisted_7 = {
  style: {
    "padding": "5px 0",
    "box-shadow": "0 2px 12px rgba(50,50,51,.12)",
    "background-color": "var(--atbg-color)",
    "border-radius": "5px"
  }
};
const _hoisted_8 = {
  class: "chart"
};
const _hoisted_9 = {
  class: "side"
};
const _hoisted_10 = {
  key: 1,
  class: "ieo-content-slot"
};
const _hoisted_11 = {
  key: 1,
  class: "ieo-trade-column",
  style: {
    "width": "32%",
    "align-self": "stretch",
    "display": "flex",
    "flex-direction": "column",
    "background-color": "var(--bg-color)"
  }
};
const _hoisted_12 = {
  key: 2,
  style: {
    "width": "100%"
  }
};
const _hoisted_13 = {
  key: 3,
  class: "area-l area-side"
};
const _hoisted_14 = {
  class: "search"
};
const _hoisted_15 = {
  class: "header"
};
const _hoisted_16 = {
  class: "header-item left"
};
const _hoisted_17 = {
  class: "header-item center"
};
const _hoisted_18 = {
  class: "header-item right"
};
const _hoisted_19 = {
  class: "data-list"
};
const _hoisted_20 = ["onClick"];
const _hoisted_21 = {
  class: "left",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "star"
};
const _hoisted_24 = {
  class: "data-list"
};
const _hoisted_25 = ["onClick"];
const _hoisted_26 = {
  class: "left",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "star"
};
const _hoisted_29 = {
  key: 4,
  class: "area-center"
};
const _hoisted_30 = {
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_31 = ["onClick"];
const _hoisted_32 = {
  style: {
    "font-size": "14px",
    "color": "#147797",
    "cursor": "pointer",
    "margin-right": "30px"
  }
};
const _hoisted_33 = {
  style: {
    "padding": "5px 0",
    "box-shadow": "0 2px 12px rgba(50,50,51,.12)",
    "background-color": "var(--atbg-color)",
    "border-radius": "5px"
  }
};
const _hoisted_34 = {
  class: "chart"
};
const _hoisted_35 = {
  class: "side"
};
const _hoisted_36 = {
  key: 5,
  class: "area-r area-side"
};
const _hoisted_37 = {
  key: 6,
  class: "dropmodal-right area-r area-side"
};
const _hoisted_38 = {
  class: "header"
};
const _hoisted_39 = {
  class: "header-item left"
};
const _hoisted_40 = {
  class: "header-item center"
};
const _hoisted_41 = {
  class: "header-item right"
};
const _hoisted_42 = {
  key: 7,
  class: "dropmodal-right area-r area-side"
};
const _hoisted_43 = {
  class: "header"
};
const _hoisted_44 = {
  class: "header-item left"
};
const _hoisted_45 = {
  class: "header-item center"
};
const _hoisted_46 = {
  class: "header-item right"
};
const _hoisted_47 = {
  class: "right"
};
import { ref, onMounted, onBeforeUnmount, watch, computed, onUpdated } from 'vue';
import store from '@/store';
import TradeHeader from '@/components/TradeHeader.vue';
import DataBlock from '@/components/DataBlock.vue';
import ChartToolsBar from '@/components/ChartToolsBar.vue';
import { dispose, init } from 'klinecharts';
import wssId from '@/util/wssId';
import dayjs from "dayjs";
// import BigNumber from "bignumber.js"
import { useI18n } from 'vue-i18n';
import { fmtNumber } from '@/util';
import TradingViewKline from '@/components/charts/TradingViewKline.vue';
import { StarOutlined, StarFilled, SearchOutlined } from '@ant-design/icons-vue';
export default {
  __name: 'TradeArea',
  props: {
    klineKey: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '980px'
    },
    keyList: {
      type: Array,
      default: () => []
    },
    ieo: {
      type: Boolean,
      default: false
    },
    showIeoKline: {
      type: Boolean,
      default: true
    },
    klineHeight: {
      type: String,
      default: '560px'
    },
    active: {
      type: Number,
      default: 0
    }
  },
  emits: ['change'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    _useCssVars(_ctx => ({
      "c26e3b34": _ctx.grayFont
    }));
    const {
      t
    } = useI18n();
    const isLight = ref(true);
    const tradingViewRef = ref(null);
    const segmentedValue = ref('Original');
    const segmentedChange = index => {
      if (index.target.value == 'Original') {
        // chart.removeTechnicalIndicator('vol_pane', 'VOL')
        // chart.createTechnicalIndicator('CR', false, {
        //   id: 'pane_1',
        //   dragEnabled: true,
        // });
        // chart.removeTechnicalIndicator('pane_1', 'CR')
        // chart.createTechnicalIndicator({ name: 'VOL', calcParams: [10], styles: { margin: { top: 0.2, bottom: 2 } } }, false, { id: 'vol_pane' })
      }
      if (index.target.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }
    };
    const decimal = ref(8);
    const maxNum = ref(0);
    const minNum = ref(0);
    const tabsKey = ref('0');
    const searchValue = ref('');
    const coinArr = computed(() => {
      var arr = [];
      props.keyList.forEach(item => {
        if (item.indexOf(searchValue.value.toUpperCase()) != -1) arr.push(item);
      });
      return arr;
    });
    const starCoinArr = computed(() => {
      var arr = [];
      store.state.starKey.forEach(item => {
        if (item.indexOf(searchValue.value.toUpperCase()) != -1) arr.push(item);
      });
      return arr;
    });
    const klineKeyWatch = watch(() => props.klineKey, async () => {
      if (props.ieo && !props.showIeoKline) return;
      if (wssConnect && wss) {
        if (segmentedValue.value == 'TradingView') {
          tradingViewRef.value.tvInit();
        }
        tradingViewRef.value.chartData = [];
        wss.send(JSON.stringify({
          id: wssId['kline.unsubscribe'],
          method: 'kline.unsubscribe',
          params: []
        }));
        first.value = true;
        // now = dayjs().unix()
        lastKline.value = null;
        klineMore();
      }
      decimal.value = store.state.marketInfo[props.klineKey].decimal;
      maxNum.value = store.state.marketInfo[props.klineKey].maxAmount;
      minNum.value = store.state.marketInfo[props.klineKey].minAmount;
    });
    let wss = null;
    // let now = dayjs().unix()
    let wssConnect = false;
    let first = ref(true);
    const last = ref('0.00');
    let wssHeart = null;

    // 指标
    const indicatorList = ref([]);
    const showPopover = ref(false);
    let indicatorKey = {};
    const dealList = ref([]);
    let dealTimer = null;
    let leaving = false;

    // const activeKey = ref('0')

    let chart = null;
    const klineActive = ref(0);
    const klineSecond = [60, 300, 900, 1800, 3600, 86400, 604800];
    const lastKline = ref(null); //query查询上一次的0位数值

    const showAreaL = ref(false);
    const showHandicap = ref(false);
    const showRealTime = ref(false);
    const fmtTime = ts => {
      return dayjs(ts * 1000).format('HH:mm:ss');
    };
    const timeChange = index => {
      if (segmentedValue.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }
      tradingViewRef.value.chartData = [];
      klineActive.value = index;
      wss.send(JSON.stringify({
        id: wssId['kline.unsubscribe'],
        method: 'kline.unsubscribe',
        params: []
      }));
      first.value = true;
      // now = dayjs().unix()
      lastKline.value = null;
      klineMore();
    };
    let klineLoading = false;
    const klineMore = () => {
      if (klineLoading) {
        setTimeout(klineMore, 1000);
        return;
      }
      klineLoading = true;
      if (props.klineKey !== '' && wssConnect && wss) {
        // const diff = BigNumber(klineSecond[klineActive.value]).multipliedBy(300).toNumber()
        // const form = BigNumber(now).minus(diff).toNumber()
        let lk = lastKline.value ? String(lastKline.value[0]) : '';
        wss.send(JSON.stringify({
          id: wssId['kline.query'],
          method: 'kline.query',
          params: [props.klineKey, String(klineSecond[klineActive.value]), lk]
        }));
      } else {
        klineLoading = false;
      }
    };
    const chartDraw = shapeName => {
      chart.createShape(shapeName);
    };
    const chartClear = () => {
      chart.removeShape();
    };
    let eee = () => {
      if (props.ieo && !props.showIeoKline) return;
      chart.setPriceVolumePrecision(store.state.marketInfo[props.klineKey].decimal, store.state.marketInfo[props.klineKey].decimal);
    };
    expose({
      eee
    });
    onUpdated(() => {
      if (isLight.value != Boolean(localStorage.getItem('isLight') == 'true')) isLight.value = Boolean(localStorage.getItem('isLight') == 'true');
    });
    onMounted(() => {
      if (props.ieo && !props.showIeoKline) return;
      klineActive.value = props.active;
      chart = init('kline-chart', {
        candle: {
          tooltip: {
            showRule: 'follow_cross',
            showType: 'rect',
            labels: [t('time'), t('open'), t('close'), t('high'), t('low'), t('volume')]
          }
        },
        grid: {
          show: false
        }
      });
      chart.setTimezone('America/New_York');
      chart.setOffsetRightSpace(20);
      chart.createTechnicalIndicator({
        name: 'VOL',
        calcParams: [10],
        styles: {
          margin: {
            top: 0.2,
            bottom: 2
          }
        }
      });
      chart.createTechnicalIndicator({
        name: 'MA',
        shortName: 'MA',
        calcParams: [10, 20, 30],
        dragEnabled: true,
        plots: [{
          key: 'ma1',
          title: 'MA10: ',
          type: 'line'
        }, {
          key: 'ma2',
          title: 'MA20: ',
          type: 'line'
        }, {
          key: 'ma3',
          title: 'MA30: ',
          type: 'line'
        }],
        regeneratePlots: params => {
          return params.map((p, i) => {
            return {
              key: `ma${i + 1}`,
              title: `MA${p}: `,
              type: 'line'
            };
          });
        }
      }, true, {
        id: 'candle_pane',
        dragEnabled: true
      });
      chart.loadMore(klineMore);
      wssInit();
    });
    const dealSend = () => {
      dealTimer = setInterval(() => {
        if (wssConnect && wss) {
          wss.send(JSON.stringify({
            id: wssId['deals.query'],
            method: 'deals.info',
            params: [props.klineKey, '30']
          }));
        }
      }, 2000);
    };
    let closeHeart = null;
    let restart = false;
    const wssInit = () => {
      clearInterval(wssHeart);
      clearInterval(dealTimer);
      wss = new WebSocket(process.env.VUE_APP_WSS);
      wss.onopen = () => {
        wssConnect = true;
        klineMore();
        dealSend();
        wssHeart = setInterval(() => {
          if (wssConnect && wss) {
            wss.send(1);
          }
        }, 10000);
        if (segmentedValue.value == 'TradingView') {
          tradingViewRef.value.tvInit();
        }
      };
      wss.onmessage = res => {
        const data = JSON.parse(res.data);
        if (data.method) {
          switch (data.method) {
            case 'kline.query':
              data.result.forEach((item, index) => {
                if (index == 0) lastKline.value = item;
              });
              if (segmentedValue.value == 'TradingView' && tradingViewRef.value.tvHistoryFunction) tradingViewRef.value.tvHistoryFunction(data);
              if (first.value) {
                const klineInfo = store.state.marketInfo[props.klineKey];
                if (klineInfo) {
                  chart.setPriceVolumePrecision(klineInfo.decimal, klineInfo.decimal);
                }
                chart.applyNewData(data.result.map(item => {
                  return {
                    timestamp: Number(item[0] * 1000),
                    open: Number(item[1]),
                    high: Number(item[3]),
                    low: Number(item[4]),
                    close: Number(item[2]),
                    volume: Number(item[5])
                  };
                }), data.result.length >= 300);
                // if (data.result.length > 0) {
                //   now = BigNumber(data.result[0][0]).minus(klineSecond[klineActive.value]).toNumber()
                // }
                first.value = false;
                wss.send(JSON.stringify({
                  id: wssId['kline.subscribe'],
                  method: 'kline.subscribe',
                  params: [props.klineKey, String(klineSecond[klineActive.value])]
                }));
              } else {
                chart.applyMoreData(data.result.map(item => {
                  return {
                    timestamp: Number(item[0] * 1000),
                    open: Number(item[1]),
                    high: Number(item[3]),
                    low: Number(item[4]),
                    close: Number(item[2]),
                    volume: Number(item[5])
                  };
                }), data.result.length >= 300);
                // if (data.result.length > 0) {
                //   now = BigNumber(data.result[0][0]).minus(klineSecond[klineActive.value]).toNumber()
                // }
              }

              if (restart) {
                wss.send(JSON.stringify({
                  id: wssId['kline.unsubscribe'],
                  method: 'kline.unsubscribe',
                  params: []
                }));
                wss.send(JSON.stringify({
                  id: wssId['kline.subscribe'],
                  method: 'kline.subscribe',
                  params: [props.klineKey, String(klineSecond[klineActive.value])]
                }));
                restart = false;
              }

              //保存k线数据，给tradingview使用
              var arr = [];
              for (var i = 0; i < data.result.length; i++) {
                var item = data.result[i];
                arr.push({
                  time: item[0] * 1000,
                  open: Number(item[1]),
                  high: Number(item[3]),
                  low: Number(item[4]),
                  close: Number(item[2]),
                  volume: Number(item[5])
                });
              }
              arr.push(...tradingViewRef.value.chartData);
              tradingViewRef.value.chartData = arr;
              klineLoading = false;
              break;
            case 'kline.update':
              if (segmentedValue.value == 'TradingView' && tradingViewRef.value.tvScribeFunction != null) tradingViewRef.value.tvScribeFunction(data);
              if (data.result) {
                last.value = data.result[2];
                chart.updateData({
                  timestamp: Number(data.result[0] * 1000),
                  open: Number(data.result[1]),
                  high: Number(data.result[3]),
                  low: Number(data.result[4]),
                  close: Number(data.result[2]),
                  volume: Number(data.result[5])
                });
              }
              break;
            case 'deals.info':
              dealList.value = data.result;
              dealList.value = dealList.value.map(item => {
                return JSON.parse(item);
              });
              break;
          }
        }
      };
      wss.onclose = () => {
        if (!leaving) {
          clearInterval(wssHeart);
          wssConnect = false;
          restart = true;
          clearInterval(dealTimer);
          closeHeart = setTimeout(() => {
            if (!leaving) {
              wssInit();
            }
          }, 5000);
        }
      };
    };
    const langWatch = watch(() => store.state.lang, () => {
      if (props.ieo && !props.showIeoKline) return;
      if (!chart) return;
      chart.setStyleOptions({
        candle: {
          tooltip: {
            labels: [t('time'), t('open'), t('close'), t('high'), t('low'), t('volume')]
          }
        }
      });
      if (segmentedValue.value == 'TradingView') {
        tradingViewRef.value.tvInit();
      }
    });
    const indicatorChange = name => {
      if (indicatorList.value.includes(name)) {
        if (name == "RSI") indicatorKey[name] = chart.createTechnicalIndicator({
          name: 'RSI',
          calcParams: [12],
          precision: 4
        }, false, {
          height: 90
        });else indicatorKey[name] = chart.createTechnicalIndicator(name, false, {
          height: 90
        });
      } else {
        if (indicatorKey[name]) {
          chart.removeTechnicalIndicator(indicatorKey[name]);
        }
      }
    };
    onBeforeUnmount(() => {
      leaving = true;
      if (props.ieo && !props.showIeoKline) {
        langWatch();
        klineKeyWatch();
        return;
      }
      clearTimeout(closeHeart);
      dispose('kline-chart');
      wssConnect = false;
      try {
        wss.close();
      } finally {
        langWatch();
        clearInterval(dealTimer);
        clearInterval(wssHeart);
        klineKeyWatch();
      }
    });
    onMounted(() => {
      // tradingViewRef.value.tvInit()
    });
    return (_ctx, _cache) => {
      const _component_a_radio_button = _resolveComponent("a-radio-button");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_van_checkbox = _resolveComponent("van-checkbox");
      const _component_van_checkbox_group = _resolveComponent("van-checkbox-group");
      const _component_a_dropdown = _resolveComponent("a-dropdown");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.ieo ? _renderSlot(_ctx.$slots, "trade-header", {
        key: 0
      }) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass(["trade-area", {
          'ieo-trade-area': __props.ieo
        }])
      }, [__props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_2, [props.showIeoKline ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
        class: "kline",
        style: _normalizeStyle({
          paddingTop: props.ieo ? '5px' : '0px'
        })
      }, [_createVNode(TradingViewKline, {
        ref_key: "tradingViewRef",
        ref: tradingViewRef,
        segmentedValue: segmentedValue.value,
        klineActive: klineActive.value,
        klineHeight: __props.klineHeight,
        decimal: decimal.value,
        klineKey: props.klineKey,
        first: _unref(first),
        klineSecond: klineSecond,
        onKlineMore: klineMore
      }, {
        time: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([`1${_unref(t)('minute')}`, `5${_unref(t)('minute')}`, `15${_unref(t)('minute')}`, `30${_unref(t)('minute')}`, `1${_unref(t)('hour')}`, `1${_unref(t)('day')}`, `1${_unref(t)('week')}`], (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "time-item",
            style: _normalizeStyle({
              color: klineActive.value === index ? '#147797' : ''
            }),
            onClick: $event => timeChange(index),
            key: index
          }, _toDisplayString(item), 13, _hoisted_5);
        }), 128))])]),
        segmented: _withCtx(() => [_createVNode(_component_a_radio_group, {
          value: segmentedValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => segmentedValue.value = $event),
          onChange: segmentedChange,
          "button-style": "solid",
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_button, {
            value: "Original"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('original')), 1)]),
            _: 1
          }), _createVNode(_component_a_radio_button, {
            value: "TradingView"
          }, {
            default: _withCtx(() => [_createTextVNode("Trading View")]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"])]),
        indicator: _withCtx(() => [_createVNode(_component_a_dropdown, {
          visible: showPopover.value,
          "onUpdate:visible": _cache[6] || (_cache[6] = $event => showPopover.value = $event),
          placement: "bottom"
        }, {
          overlay: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_checkbox_group, {
            modelValue: indicatorList.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => indicatorList.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "MACD",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[1] || (_cache[1] = $event => indicatorChange('MACD'))
            }, {
              default: _withCtx(() => [_createTextVNode("MACD")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "BOLL",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[2] || (_cache[2] = $event => indicatorChange('BOLL'))
            }, {
              default: _withCtx(() => [_createTextVNode("BOLL")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "KDJ",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[3] || (_cache[3] = $event => indicatorChange('KDJ'))
            }, {
              default: _withCtx(() => [_createTextVNode("KDJ")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "RSI",
              onClick: _cache[4] || (_cache[4] = $event => indicatorChange('RSI'))
            }, {
              default: _withCtx(() => [_createTextVNode("RSI")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('indicator')), 1)]),
          _: 1
        }, 8, ["visible"])]),
        chart: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(ChartToolsBar, {
          onDraw: chartDraw,
          onClear: chartClear
        })]), _createElementVNode("div", {
          id: "kline-chart",
          style: _normalizeStyle({
            height: props.klineHeight,
            width: '100%'
          })
        }, null, 4)])]),
        _: 1
      }, 8, ["segmentedValue", "klineActive", "klineHeight", "decimal", "klineKey", "first"])], 4)])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_renderSlot(_ctx.$slots, "ieo-content")]))])) : _createCommentVNode("", true), __props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_renderSlot(_ctx.$slots, "default"), _renderSlot(_ctx.$slots, "ieo1"), _renderSlot(_ctx.$slots, "step")])) : _createCommentVNode("", true), !__props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_12, [!__props.ieo ? (_openBlock(), _createBlock(TradeHeader, {
        key: 0,
        name: _unref(store).state.marketInfo[props.klineKey]?.name,
        last: Number(last.value).toFixed(decimal.value),
        growth: _unref(store).state.market[props.klineKey]?.growth,
        up: _unref(store).state.market[props.klineKey]?.up,
        high: Number(_unref(store).state.market[props.klineKey]?.high).toFixed(decimal.value),
        low: Number(_unref(store).state.market[props.klineKey]?.low).toFixed(decimal.value),
        vol: _unref(store).state.market[props.klineKey]?.volume,
        style: {
          "background-color": "var(--bg-color)",
          "color": "var(--text-color)"
        },
        arrow: showAreaL.value,
        onChangeArrow: _cache[7] || (_cache[7] = bool => {
          showAreaL.value = bool;
        }),
        arrow1: showHandicap.value,
        onChangeArrow1: _cache[8] || (_cache[8] = bool => {
          showHandicap.value = false;
          showRealTime.value = false;
          showHandicap.value = bool;
        }),
        arrow2: showRealTime.value,
        onChangeArrow2: _cache[9] || (_cache[9] = bool => {
          showHandicap.value = false;
          showRealTime.value = false;
          showRealTime.value = bool;
        })
      }, null, 8, ["name", "last", "growth", "up", "high", "low", "vol", "arrow", "arrow1", "arrow2"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !__props.ieo && showAreaL.value ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_a_input, {
        value: searchValue.value,
        "onUpdate:value": _cache[10] || (_cache[10] = $event => searchValue.value = $event),
        placeholder: _unref(t)('selectText'),
        "enter-button": "",
        allowClear: ""
      }, {
        prefix: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
        _: 1
      }, 8, ["value", "placeholder"])]), _createVNode(_component_a_tabs, {
        activeKey: tabsKey.value,
        "onUpdate:activeKey": _cache[11] || (_cache[11] = $event => tabsKey.value = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
          key: "0",
          tab: _unref(t)('all')
        }, null, 8, ["tab"]), _createVNode(_component_a_tab_pane, {
          key: "1",
          tab: _unref(t)('favorites')
        }, null, 8, ["tab"])]),
        _: 1
      }, 8, ["activeKey"]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('currencyType')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('fastPrice')), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(t)('trend')), 1)]), _withDirectives(_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coinArr), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["data-item", {
            active: props.klineKey === item
          }]),
          key: index,
          onClick: $event => {
            showAreaL.value = false;
            showHandicap.value = false;
            showRealTime.value = false;
            emit('change', item);
          }
        }, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
          src: _unref(store).state.marketInfo[item]?.icon,
          style: {
            "width": "17px",
            "margin-right": "6px"
          }
        }, null, 8, _hoisted_22), _createElementVNode("span", null, _toDisplayString(_unref(store).state.marketInfo[item]?.name) + "/USDT", 1)]), _createElementVNode("div", {
          class: "center",
          style: _normalizeStyle({
            color: _unref(store).state.market[item]?.up ? '#04AC92' : '#EC2752'
          })
        }, _toDisplayString(Number(_unref(store).state.market[item]?.last).toFixed(_unref(store).state.marketInfo[item]?.decimal)), 5), _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle({
            color: _unref(store).state.market[item]?.up ? '#04AC92' : '#EC2752'
          })
        }, _toDisplayString(_unref(store).state.market[item]?.growth) + "%", 5), _createElementVNode("div", _hoisted_23, [_unref(store).state.marketInfo[item]?.starShow ? (_openBlock(), _createBlock(_unref(StarFilled), {
          key: 0,
          onClick: _withModifiers($event => _unref(store).commit('addStar', {
            id: _unref(store).state.marketInfo[item]?.id,
            select: 0
          }), ["stop"])
        }, null, 8, ["onClick"])) : (_openBlock(), _createBlock(_unref(StarOutlined), {
          key: 1,
          onClick: _withModifiers($event => _unref(store).commit('addStar', {
            id: _unref(store).state.marketInfo[item]?.id,
            select: 1
          }), ["stop"])
        }, null, 8, ["onClick"]))])], 10, _hoisted_20);
      }), 128))], 512), [[_vShow, tabsKey.value == '0']]), _withDirectives(_createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(starCoinArr), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["data-item", {
            active: props.klineKey === item
          }]),
          key: index,
          onClick: $event => {
            showAreaL.value = false;
            showHandicap.value = false;
            showRealTime.value = false;
            emit('change', item);
          }
        }, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
          src: _unref(store).state.marketInfo[item]?.icon,
          style: {
            "width": "17px",
            "margin-right": "6px"
          }
        }, null, 8, _hoisted_27), _createElementVNode("span", null, _toDisplayString(_unref(store).state.marketInfo[item]?.name) + "/USDT", 1)]), _createElementVNode("div", {
          class: "center",
          style: _normalizeStyle({
            color: _unref(store).state.market[item]?.up ? '#04AC92' : '#EC2752'
          })
        }, _toDisplayString(Number(_unref(store).state.market[item]?.last).toFixed(_unref(store).state.marketInfo[item]?.decimal)), 5), _createElementVNode("div", {
          class: "right",
          style: _normalizeStyle({
            color: _unref(store).state.market[item]?.up ? '#04AC92' : '#EC2752'
          })
        }, _toDisplayString(_unref(store).state.market[item]?.growth) + "%", 5), _createElementVNode("div", _hoisted_28, [_unref(store).state.marketInfo[item]?.starShow ? (_openBlock(), _createBlock(_unref(StarFilled), {
          key: 0,
          onClick: _withModifiers($event => _unref(store).commit('addStar', {
            id: _unref(store).state.marketInfo[item]?.id,
            select: 0
          }), ["stop"])
        }, null, 8, ["onClick"])) : (_openBlock(), _createBlock(_unref(StarOutlined), {
          key: 1,
          onClick: _withModifiers($event => _unref(store).commit('addStar', {
            id: _unref(store).state.marketInfo[item]?.id,
            select: 1
          }), ["stop"])
        }, null, 8, ["onClick"]))])], 10, _hoisted_25);
      }), 128))], 512), [[_vShow, tabsKey.value == '1']])])) : _createCommentVNode("", true), !__props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", {
        class: "kline",
        style: _normalizeStyle({
          paddingTop: props.ieo ? '5px' : '0px'
        })
      }, [_createVNode(TradingViewKline, {
        ref_key: "tradingViewRef",
        ref: tradingViewRef,
        segmentedValue: segmentedValue.value,
        klineActive: klineActive.value,
        klineHeight: __props.klineHeight,
        decimal: decimal.value,
        klineKey: props.klineKey,
        first: _unref(first),
        klineSecond: klineSecond,
        onKlineMore: klineMore
      }, {
        time: _withCtx(() => [_createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList([`1${_unref(t)('minute')}`, `5${_unref(t)('minute')}`, `15${_unref(t)('minute')}`, `30${_unref(t)('minute')}`, `1${_unref(t)('hour')}`, `1${_unref(t)('day')}`, `1${_unref(t)('week')}`], (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "time-item",
            style: _normalizeStyle({
              color: klineActive.value === index ? '#147797' : ''
            }),
            onClick: $event => timeChange(index),
            key: index
          }, _toDisplayString(item), 13, _hoisted_31);
        }), 128))])]),
        segmented: _withCtx(() => [_createVNode(_component_a_radio_group, {
          value: segmentedValue.value,
          "onUpdate:value": _cache[12] || (_cache[12] = $event => segmentedValue.value = $event),
          onChange: segmentedChange,
          "button-style": "solid",
          size: "small"
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio_button, {
            value: "Original"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('original')), 1)]),
            _: 1
          }), _createVNode(_component_a_radio_button, {
            value: "TradingView"
          }, {
            default: _withCtx(() => [_createTextVNode("Trading View")]),
            _: 1
          })]),
          _: 1
        }, 8, ["value"])]),
        indicator: _withCtx(() => [_createVNode(_component_a_dropdown, {
          visible: showPopover.value,
          "onUpdate:visible": _cache[18] || (_cache[18] = $event => showPopover.value = $event),
          placement: "bottom"
        }, {
          overlay: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_van_checkbox_group, {
            modelValue: indicatorList.value,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => indicatorList.value = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "MACD",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[13] || (_cache[13] = $event => indicatorChange('MACD'))
            }, {
              default: _withCtx(() => [_createTextVNode("MACD")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "BOLL",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[14] || (_cache[14] = $event => indicatorChange('BOLL'))
            }, {
              default: _withCtx(() => [_createTextVNode("BOLL")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "KDJ",
              style: {
                "margin-bottom": "10px"
              },
              onClick: _cache[15] || (_cache[15] = $event => indicatorChange('KDJ'))
            }, {
              default: _withCtx(() => [_createTextVNode("KDJ")]),
              _: 1
            }), _createVNode(_component_van_checkbox, {
              shape: "square",
              "icon-size": "18",
              name: "RSI",
              onClick: _cache[16] || (_cache[16] = $event => indicatorChange('RSI'))
            }, {
              default: _withCtx(() => [_createTextVNode("RSI")]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_32, _toDisplayString(_unref(t)('indicator')), 1)]),
          _: 1
        }, 8, ["visible"])]),
        chart: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_createVNode(ChartToolsBar, {
          onDraw: chartDraw,
          onClear: chartClear
        })]), _createElementVNode("div", {
          id: "kline-chart",
          style: _normalizeStyle({
            height: props.klineHeight,
            width: '100%'
          })
        }, null, 4)])]),
        _: 1
      }, 8, ["segmentedValue", "klineActive", "klineHeight", "decimal", "klineKey", "first"])], 4)])) : _createCommentVNode("", true), !__props.ieo ? (_openBlock(), _createElementBlock("div", _hoisted_36, [_renderSlot(_ctx.$slots, "default")])) : _createCommentVNode("", true), !__props.ieo && showHandicap.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('level')), 1), _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)('price')), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(_unref(t)('number')), 1)]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(17, index => {
        return _createVNode(DataBlock, {
          key: index,
          index: index,
          bg: isLight.value ? 'rgba(251, 243, 241, .6)' : 'rgba(202,63,100,.2)',
          decimal: decimal.value,
          "color-l": "#EC234D",
          max: maxNum.value,
          min: minNum.value,
          price: last.value,
          top: true
        }, null, 8, ["index", "bg", "decimal", "max", "min", "price"]);
      }), 64)), _createElementVNode("div", {
        class: "current-price",
        style: _normalizeStyle({
          color: _unref(store).state.market[props.klineKey]?.up ? '#04AC92' : '#EC2752'
        })
      }, _toDisplayString(Number(last.value).toFixed(decimal.value)), 5), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(17, index => {
        return _createVNode(DataBlock, {
          key: index,
          index: index,
          bg: isLight.value ? 'rgba(234, 249, 246, .6)' : 'rgba(37,167,80,.2)',
          decimal: decimal.value,
          "color-l": "#269B8B",
          max: maxNum.value,
          min: minNum.value,
          price: last.value
        }, null, 8, ["index", "bg", "decimal", "max", "min", "price"]);
      }), 64))])) : _createCommentVNode("", true), !__props.ieo && showRealTime.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('price')), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(t)('number')), 1), _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)('time')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dealList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "deal-item",
          key: item.id
        }, [_createElementVNode("div", {
          class: "left",
          style: _normalizeStyle({
            color: item.type == '0' ? '#04AC92' : '#D04C64'
          })
        }, _toDisplayString(_unref(fmtNumber)(item.price)), 5), _createElementVNode("div", {
          class: "center",
          style: _normalizeStyle({
            color: item.type == '0' ? '#04AC92' : '#D04C64'
          })
        }, _toDisplayString(_unref(fmtNumber)(Number(item.amount).toFixed(decimal.value))), 5), _createElementVNode("div", _hoisted_47, _toDisplayString(fmtTime(item.time)), 1)]);
      }), 128))])) : _createCommentVNode("", true)], 2)]);
    };
  }
};